export default "__VITE_ASSET__DsEGb_0$__"